import { setAuthInHeader } from '../api/request'

const mutations = {
  increment (state){
    return state.count++;
  },
  LOGIN (state, {token}) {
    state.token = token;
    this.$sessionStorage.set('token', token);
    setAuthInHeader(token);
  },
  LOGOUT (state) {
    state.token = null;
    this.$sessionStorage.remove('token');
    setAuthInHeader(null);
  },
};


export default mutations
